
export class InvalidRequestError extends Error {
    readonly type = "InvalidRequestError" as const;
}

export class ConflictRequestError extends Error {
    readonly type = "ConflictRequestError" as const;
}

export class UnexpectedError extends Error {
    readonly type = "UnexpectedError" as const;
}

export class NotFoundRequestError extends Error {
    readonly type = "NotFoundRequestError" as const;
}



export type ResponseError = ConflictRequestError | InvalidRequestError | UnexpectedError | NotFoundRequestError;
